var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("mainController", [
    "$scope", "$rootScope", "$window", "$document", "accountService", "mainService", "cartService", "storageFactory", "specialsService", "helperService", "storefrontApp.mainContext", "commonService",
    function (
        $scope, $rootscope, $window, $document, accountService, mainService, cartService, storageFactory, specialsService, helperService, storefrontAppMainContext, commonService
    ) {
        //Base store url populated in layout and can be used for construction url inside controller
        $scope.baseUrl = {};

        // For outside app redirect (To reload the page after changing the URL, use the lower-level API)
        $scope.outerRedirect = function (absUrl) {
            $window.location.href = absUrl;
        };

        //#region Header and Footer Content
        $scope.getNavbarContent = function () {
            // #region Private Functions
            function filterData(data, key, value) {
                var filteredData = data.filter(function (data) {
                    return (
                        (data[key] && data[key].toLowerCase()) ==
                        value.toLowerCase()
                    );
                });
                return filteredData &&
                    filteredData != null &&
                    filteredData.length > 0
                    ? filteredData[0]
                    : undefined;
            }
            //#endregion

            mainService.getNavbarContent().then(function (response) {
                if (response && response.data && response.data.length > 0) {
                    var footerContent = filterData(
                        response.data, "section", "footer"
                    );
                    if (footerContent) {
                        $scope.footerContent = footerContent.content;
                        $scope.currentDate = new Date(); // For Copyright Year
                    }
                    var headerContent = filterData(
                        response.data, "section", "header"
                    );
                    if (headerContent) {
                        $scope.headerContent = headerContent.content;
                    }
                    var mobileNavContent = filterData(
                        response.data, "section", "mobile"
                    );
                    if (mobileNavContent) {
                        $scope.mobileNavContent = mobileNavContent.content;
                    }
                }
            });
        };

        $scope.updateSuperHeaderImage = function(){
            if($scope.superHeaderAds){
                var imgUrl = $scope.superHeaderAds.imageURL;
                var img = $document[0].getElementById("superHeader");
                var container = $document[0].getElementById("superHeaderContainer");
                if(angular.isDefined(container) && angular.isDefined(img) && angular.isDefined(imgUrl)){
                    container.style.display = "block";
                    if($scope.windowWidth > 1599){
                        img.src = imgUrl;
                    }
                    else if ($scope.windowWidth > 1199){
                        img.src = imgUrl.substring(0, imgUrl.lastIndexOf(".")) + "_lg" + imgUrl.substring(imgUrl.lastIndexOf("."))
                    }
                    else if ($scope.windowWidth > 767){
                        img.src = imgUrl.substring(0, imgUrl.lastIndexOf(".")) + "_md" + imgUrl.substring(imgUrl.lastIndexOf("."))
                    }
                    else if ($scope.windowWidth > 575){
                        img.src = imgUrl.substring(0, imgUrl.lastIndexOf(".")) + "_sm" + imgUrl.substring(imgUrl.lastIndexOf("."))
                    }
                    else if ($scope.windowWidth > 359){
                        img.src = imgUrl.substring(0, imgUrl.lastIndexOf(".")) + "_xs" + imgUrl.substring(imgUrl.lastIndexOf("."))
                    }
                    else{
                        container.style.display = "none";
                    }
                }
            }
        }

        $scope.getActiveSales = function(){
            $scope.windowWidth = $window.innerWidth;
            angular.element($window).bind("resize", function () {
                $scope.windowWidth = $window.innerWidth;
                $scope.updateSuperHeaderImage();
            });
            helperService.getResetCacheState("HomepageAds").then(
                function (response) {
                    if (response) {
                        var resetCache = response.data;
                        //#region Sales
                        var sales_data = helperService.getContent(
                            storageFactory.get("activeSales")
                        );
                        if (resetCache || sales_data == null) {
                            specialsService.getActiveSales(false).then(
                                function (response) {
                                    if(response && response.data){
                                        $rootscope.sales = [];
                                        response.data.forEach(function(sale){
                                            if (angular.isDefined(sale.saleUrl) && sale.saleUrl != ''){
                                                $rootscope.sales.push({
                                                    "href": sale.saleUrl, "title": sale.name
                                                });
                                            }
                                        });
                                        if(angular.isDefined($rootscope.sales) && $rootscope.sales.length > 0){
                                            storageFactory.set("activeSales", JSON.stringify($rootscope.sales), true);
                                        }
                                    }
                                }
                            );
                        }
                        else{
                            $rootscope.sales = JSON.parse(sales_data);
                        }
                        // #endregion

                        //#region Super Header Ads
                        var sHeader_data = helperService.getContent(
                            storageFactory.get("sHeaderAds")
                        );
                        if (sHeader_data == null || response.data) {
                            mainService.getSuperHeaderAds().then(
                                function (response) {
                                    if (response) {
                                        $scope.superHeaderAds = (response.data && response.data.length > 0) ? response.data[0] : null;
                                        $scope.updateSuperHeaderImage();
                                        storageFactory.set("sHeaderAds", JSON.stringify(response.data), true);
                                    }
                                }
                            )
                        }
                        else {
                            var data = JSON.parse(sHeader_data);
                            $scope.superHeaderAds = data.length > 0 ? data[0] : null;
                            $scope.updateSuperHeaderImage();
                        }
                    }
                    //#endregion
                }
            )
        }

        $rootscope.logoutUrl = "account/logout";

        //#endregion

        //Check browser supports webp
        function support_format_webp()
        {
            var elem = document.createElement('canvas');
            if (!!(elem.getContext && elem.getContext('2d')))
            {
                // was able or not to get WebP representation
                return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
            }
            else
            {
                return false; // very old browser like IE 8, canvas not supported
            }
        }
        $rootscope.supportsWebp = support_format_webp();

        //#region Current Customer
        $scope.$on("CurrentCustomerUpdated", function () {
            getCurrentCustomer();
        });

        function getCurrentCustomer() {
            accountService.getCurrentCustomer().then(function (response) {
                storefrontAppMainContext.customer =
                    response && response.data;
            });
        }
        getCurrentCustomer();
        //#endregion

        // #region Customer Cart Features
        $scope.getCustomerCart = function () {
            cartService.getCustomerCart().then(function (response) {
                if (response.data != null) {
                    $rootscope.cartItemsCounterRS = response.data.length;
                    $rootscope.customerCartRS = _.pluck(
                        response.data,
                        "productId"
                    );
                    if (
                        window.location.href
                            .toLowerCase()
                            .indexOf("customdigitizingdetails") > -1
                    ) {
                        $rootscope.customerCdItem = [];
                        response.data.forEach(function (dt) {
                            if (
                                dt.definitionName.toLowerCase() ==
                                "customdigitizing"
                            ) {
                                var a = _.pluck(
                                    dt.customDigitizingItems,
                                    "cdRowId"
                                );
                                $rootscope.customerCdItem.push(a[0]);
                            }
                        });
                    }
                } else {
                    console.log("Cannot Get Customer Cart from Main.js");
                }
            });
        };
        $scope.getCustomerCart();

        //Enable a Watch on the CustomerCartChanged so we can get CustomerCart Everytime Cart has an Update
        $scope.$on("CustomerCartChanged", function (event, data) {
            $scope.getCustomerCart();
        });
        // #endregion

        //#region Helper function
        $scope.sendGAEvent = function(page, event){
            if (typeof gtag !== 'undefined') {
                gtag('event', page, {
                    'event_category': 'navigation',
                    'event_action': event
                });
            }
        }

        $scope.setScopeObjValuebyKey = function (key, value) {
            $scope[key] = value;
        };

        $scope.showAlert = function(message){
            alert(message);
        }
        //#endregion

        //#region scroll related section
        $window.onscroll = function (e) {
            $rootscope.scrollPosition = angular.element(window)[0].scrollY || 0;
            $rootscope.showScrollToTop = $rootscope.scrollPosition > 150;
            $rootscope.$apply();
        };

        $scope.scrollToTop = function () {
            $window.scrollTo(0, 0);
        };
        //#endregion

        //#region Live Chat
        $rootscope.isLiveChatAvailable= false;

        liveChatStatusChanged = function (data) {
            if (data && data.state != "offline") {
                $rootscope.isLiveChatAvailable = true;
            } else {
                $rootscope.isLiveChatAvailable = false;
            }
            $rootscope.$apply();
        };

        preChatSurverySubmitted = function (data) {
            if (data && data.form_data && data.form_data.length > 1) {
                var email = data.form_data[1].value;
                contactService.updateChatActivity(email);
            }
        };
        //#endregion

        // #region Locale Related
        $rootscope.locales = [
            {
                title: "English | USD",
                icon: "fas fa-flag-usa",
                lang: "en-us",
                url: ""
            },
            {
                title: "French | EUR",
                icon: "fas fa-flag",
                lang: "fr-fr",
                url: ""
            }
        ];

        // Function to get the current locale from localStorage or default to English
        function getCurrentLocale() {
            var selectedLocale = 'fr-fr';
            if(window.location.href.toLowerCase().indexOf('.com') > -1)
                selectedLocale = 'en-us';
            return $rootscope.locales.filter(function(locale) {
                return locale.lang === selectedLocale;
            })[0];
        }

        // Initialize the current locale
        $rootscope.currentLocale = getCurrentLocale();

        $rootscope.showLocale = window.__env.showLocale;
        if (window.__env.showLocale) {
            $rootscope.onLocaleClick = function() {
                // Toggle the locale active state
                $rootscope.isLocaleActive = !$rootscope.isLocaleActive;
            };

            $rootscope.onLocaleSelected = function(lang) {
                // Find the selected locale
                var selectedLocale = $rootscope.locales.filter(function(locale) {
                    return locale.lang === lang;
                })[0];

                if (selectedLocale) {
                    // Store the selected locale in localStorage
                    localStorage.setItem('selectedLocale', lang);

                    // Update the current locale
                    $rootscope.currentLocale = selectedLocale;

                    // Get the current URL
                    var currentUrl = window.location.href;

                    // Determine the new URL based on the selected locale
                    var newUrl;
                    if (lang === 'fr-fr') {
                        // Replace '.com' with '.fr' to switch to the French domain
                        newUrl = currentUrl.replace('.com', '.fr');
                    } else {
                        // Replace '.fr' with '.com' to switch to the English domain
                        newUrl = currentUrl.replace('.fr', '.com');
                    }

                    // Construct the home page URL
                    var homePageUrl = new URL('/', newUrl).href;

                    // Redirect to the home page
                    window.location.href = homePageUrl;
                }
            };
        }

        // Ensure the initial locale is correctly set in the scope
        $rootscope.$applyAsync(function() {
            $rootscope.currentLocale = getCurrentLocale();
        });



        $rootscope.localeVariables = {};
        $rootscope.setLocaleVariables = function(key, value){
            if(angular.isDefined(key) && angular.isDefined(value) && angular.isUndefined($rootscope.localeVariables[key])){
                $rootscope.localeVariables[key] = value;
            }
        }
        //#endregion

    },
])
.factory("storefrontApp.mainContext", function () {
    return {};
});
